import axios from 'axios';

const endpointAPI = 'https://y4bcssz0jc.execute-api.us-east-1.amazonaws.com/dev/users';

const ConnectionType = "Username-Password-Authentication";

export default {
  getUsers() {
    return new Promise((resolve, reject) => {
      try {
        axios.get(`${endpointAPI}`).then((res) => {
          resolve(res.data);
        });
      } catch (err) {
        reject(err);
      }
    });
  },

  addUser(newUser) {
    return new Promise(async (resolve, reject) => {

      axios.post(`${endpointAPI}`, {
        "email": newUser.Email,
        "name": newUser.Name,
        "connection": ConnectionType,
        "password": newUser.Password,
        "user_metadata": {
          "rol": newUser.Rol
        }
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        console.log(err);
        reject(err);
      });

    });
  },

  deleteUser(userId) {
    return new Promise(async (resolve, reject) => {

      axios.delete(`${endpointAPI}/${userId}`, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        console.log(err);
        reject(err);
      });

    });
  },
};
